package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.property.Property
import uk.co.nickthecoder.kyd.util.Vector2

enum class AttributeType {
    STRING,
    FLOAT,
    INT,
    BOOLEAN,
    VECTOR2
}

enum class AttributeMeaning {
    NONE,
    ACT
}

class AttributeValue private constructor(
    val value: Any,
    val type: AttributeType,
    val meaning: AttributeMeaning = AttributeMeaning.NONE
) {

    constructor(value: String, meaning: AttributeMeaning = AttributeMeaning.NONE) : this(value, AttributeType.STRING, meaning)
    constructor(value: Float) : this(value, AttributeType.FLOAT)
    constructor(value: Int) : this(value, AttributeType.INT)
    constructor(value: Boolean) : this(value, AttributeType.BOOLEAN)
    constructor(value: Vector2) : this(value, AttributeType.VECTOR2)

}

